import { ReactComponent as CheckCircle } from '@img/icons/check-circle.svg';
import EcommerceService from '@core/ecommerce/services/EcommerceService';
import Button from '@stories/Components/Buttons/Button/Button';
import Paragraph from '@stories/Components/Global/Typography/Paragraph';
import { ModalStyles } from '@stories/Components/Media/Modal/Modal.styles';
import Loader from '@stories/Components/Misc/Loader/Loader';
import { ViewHiresStyles } from '@stories/Widgets/Hires/ViewHires/ViewHires.styles';
import React, { useState } from 'react';
import { ExtendHireStyles } from './ExtendHireStyles';
import NewDatePicker from '@stories/Components/Forms/NewDatePicker/DatePicker';
import FormField from '@stories/Components/Forms/FormField/FormField';
import TextArea from '@stories/Components/Forms/TextArea/TextArea';
const ExtendHire = (props) => {
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date(props.hire.hireDateEnd || new Date()));
    const [showError, setShowError] = useState(false);
    const [error, setError] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [comments, setComments] = useState('');
    const handleExtend = async () => {
        setIsLoading(true);
        const response = await EcommerceService.offHire({
            g42OrderNumber: props.hire.orderNumber,
            newEndDate: EcommerceService.getApiFormattedDate(endDate),
            comments,
            accountId: props.accountId,
        });
        setShowError(!success);
        if (response.status.success === true) {
            setSuccess(true);
            window.setTimeout(() => {
                props.onConfirm();
            }, 10000);
        }
        else {
            setError(response.status.message);
        }
        setIsLoading(false);
    };
    if (success) {
        return (React.createElement(React.Fragment, null,
            React.createElement(ModalStyles.Title, null, props.translations['g42.hires.extendhiresuccesstitle']),
            React.createElement(Paragraph, { size: "regular", align: "center" }, props.translations['g42.hires.extendhiresuccessmessage']),
            React.createElement(ExtendHireStyles.Inner, null,
                React.createElement(ViewHiresStyles.ModalInner, null,
                    React.createElement(ViewHiresStyles.Svg, null,
                        React.createElement(CheckCircle, null))))));
    }
    if (isLoading) {
        return (React.createElement(ExtendHireStyles.Inner, null,
            React.createElement(Loader, null)));
    }
    return (React.createElement(ExtendHireStyles.Inner, null,
        React.createElement(ModalStyles.Title, null, props.translations['g42.hires.extendhirestitle']),
        React.createElement(FormField, null,
            React.createElement(NewDatePicker, { startDate: startDate, selectsEnd: true, onStartDateChanged: setStartDate, endDate: endDate, onEndDateChanged: setEndDate, inline: true })),
        React.createElement(FormField, null,
            React.createElement(TextArea, { placeholder: props.translations['g42.hires.offhire.additionaltextplaceholder'], value: comments, onChange: (e) => setComments(e.currentTarget.value), label: props.translations['g42.hires.offhire.additionaltext'] })),
        showError && React.createElement("p", null, error),
        React.createElement(Button, { title: "Confirm", branding: "primary", onClick: handleExtend })));
};
export default ExtendHire;
